import { Component, input, output } from '@angular/core';
import { TranslatePipe } from '@cmi/addin-core';
import { ContentControlInfo } from '../../../lib/word-content-controls';

@Component({
  selector: 'cmi-content-control-item',
  imports: [TranslatePipe],
  templateUrl: './content-control-item.html'
})
export class ContentControlItem {
  public readonly control = input.required<ContentControlInfo>();
  public readonly buttonTooltip = input.required<string>();
  public readonly selectItem = output<number>();

  protected onSelect(): void {
    this.selectItem.emit(this.control().id);
  }
}
